import { render, staticRenderFns } from "./BundlesPagination.vue?vue&type=template&id=72b2f100"
import script from "./BundlesPagination.vue?vue&type=script&lang=js"
export * from "./BundlesPagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports